import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import podcastImage from "@/assets/agent-user-detail/podcast@3x.webp";

export const PodcastImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[podcastImage]}
      {...props}
    />
  );
};

PodcastImage.displayName = 'PodcastImage';
